import React from 'react';
import { connect } from 'react-redux';
import InternalContainer from '../../layout/containers/Internal';
import userSchema from '../../../schemas/user';
import { BackButton } from '../../../common/components';
import UserForm from '../components/UserForm/UserForm';
import { createUser } from '../redux/userActions';

const UserCreateContainer = ({ params, location, onCreateUser }) => {
  const { organisationId, brokerId } = params;
  const { query, state } = location;

  const organisationName = state?.organisationName;
  const organisationTypeName = query?.organisationTypeName;
  const relationships = {
    ...userSchema.data.relationships,
    organisations: {
      data: [
        {
          id: organisationId,
        },
      ],
    },
  };

  if (brokerId) {
    relationships['brokers'] = {
      data: [
        {
          id: brokerId,
        },
      ],
    };

    relationships['current_broker'] = {
      data: {
        id: brokerId,
      },
    };
  }

  const resource = {
    data: {
      ...userSchema.data,
      attributes: {
        ...userSchema.data.attributes,
      },
      relationships: relationships,
    },
  };

  const save = (values) => {
    onCreateUser(values);
  };

  return (
    <InternalContainer title={'User'} buttons={<BackButton />}>
      <UserForm
        resource={resource}
        onSave={save}
        organisationTypeName={organisationTypeName}
        organisationName={organisationName}
        isOwnerUser={organisationTypeName === 'Owner'}
      />
    </InternalContainer>
  );
};

export default connect(
  null,
  {
    onCreateUser: createUser,
  },
)(UserCreateContainer);
